export default __webpack_public_path__ + "static/media/amplitude_logo.21b71989.png";